import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Form, Row, Image, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { serverApi } from "../../../../../../config/Keys";
import axios from 'axios';
import isEmpty from "../../../../../../store/validation/is-Empty";
import moment from 'moment';
import Filter from "../../../../../vendorDashboardComponents/offers/Filter";

const EventsReports = () => {
  const [eventData, setEventData] = useState([]);
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth : "";
  });

  const getData = async () => {
    let eventData = await axios.get(
      `${serverApi}/event/reports`,
      {
        params: { liveInfo: true },
        headers: {
          Authorization: auth.user.accessToken,
          "Content-Type": "application/json",
        },
      }
    );
    setEventData(eventData.data);
  }

  useEffect(() => {
    getData();
  }, [auth])

  return (
    <React.Fragment>
      <Row className="align-items-center">
        <Col className="col-auto">
          <Filter />
        </Col>
        <Col md={4}>
          <Form.Control type="text" placeholder="Search" className="amSearch" />
        </Col>
      </Row>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
        <Table className="HideShowTable enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "30%" }}>My Events</th>
              <th style={{ width: "10%" }}>Views</th>
              {/* <th style={{ width: "15%" }}>Timing</th> */}
              <th style={{ width: "15%" }}>Start Date</th>
              <th style={{ width: "15%" }}>End Date</th>
              <th style={{ width: "15%" }}>Action</th>
            </tr>
          </thead>
          {eventData.length && eventData.map(event => (
            <tbody>
              <tr className="enUserFavoritesTableBody">
                <td style={{ width: "40%" }}>
                  <div className="d-flex align-items-center">
                    <div className="text-center d-flex flex-column align-items-center" style={{ width: "60px", height: "60px" }}>
                      <Image
                        src={event?.photos[0]}
                        alt="View"
                        title="View"
                        thumbnail
                        rounded
                      />
                      <div className={`${event.isOnline ? 'enSuccessLBL' : 'enPendingLBL'} mt-2`}>{event?.isOnline ? 'Online' : 'Offline'}</div>
                    </div>
                    <div className="pl-3">
                      <div className="f12-500">{event?.name}</div>
                      <div className="f10-500">{event?.description}</div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500">{event?.eventReviewed}</div>
                </td>
                {/* <td style={{ width: "15%" }}>
                  <div className="f12-500">05:00 PM</div>
                  <div className="f12-400 pl-4 py-1">to</div>
                  <div className="f12-500">09:00 PM</div>
                </td> */}
                <td style={{ width: "15%" }}>
                  <div className="f12-500">{moment(event?.start_date).format('ll')}</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500 text-red">{moment(event?.end_date).format('ll')}</div>
                </td>
                <td style={{ width: "15%" }}>
                  <NavLink
                    to={`/reportdashboard/events/${event._id}`}
                    className="btn btn-link enIconBtn"
                  >
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </NavLink>
                </td>
              </tr>
            </tbody>
          ))}
        </Table>
      </div>
    </React.Fragment>
  );
};
export default EventsReports;

// import React, { Component } from "react";
// import Table from "react-bootstrap/Table";
// import Accordion from "react-bootstrap/Accordion";
// import { OfferEventTableHeader } from "../../../reusableComponents/allTableReusable/offerEventTable/OfferEventTableHeader";
// import { OfferEventTableBody } from "../../../reusableComponents/allTableReusable/offerEventTable/OfferEventTableBody";
// import { OfferExpendable } from "../../offers/OfferExpendable";

// export class EventsReports extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       currentState: true,
//       activeOffer: true,
//     };
//   }

//   /**************************
//    * @DESC - Current and Saving HANDLER
//    ***************************/
//   toggleFunction = (e) => {
//     this.setState({
//       [e.target.name]: e.target.checked,
//     });
//   };

//   deleteOnClick = (e) => {
//     console.log("delete Event");
//   };

//   renderTableData = () => {
//     return (
//       <React.Fragment>
//         <OfferEventTableBody
//           image={require("../../../../../../assets/images/OfferAndEventImages/eventnew.png")}
//           bigText={"Zomaland"}
//           smallText={"Avail offer on all items"}
//           view={"10"}
//           used={"Ls21"}
//           couponCode={"05:00 PM"}
//           couponCodeDisplay={true}
//           startDate={"25th Feb 20"}
//           endDate={"26th Feb 20"}
//           display={false}
//           deleteOnClick={this.deleteOnClick}
//           displayEditPopup={true}
//           displayView={false}
//         />
//       </React.Fragment>
//     );
//   };

//   renderMobileOfferCardView = () => {
//     return (
//       <React.Fragment>
//         <OfferExpendable
//           indexKey="1"
//           offerImage={require("../../../../../../assets/images/OfferAndEventImages/eventnew.png")}
//           offerHeadingText="Zomaland"
//           offerStart="25Th Feb 20"
//           offerEnd="25Th Mar 20"
//           offerCodeText="Timing"
//           offerCode="05:00 PM"
//           displayOnwards={true}
//           displayOfferEventOthres={true}
//           address="Royal Palms Pune"
//           couponCodeEvent="4"
//           name="activeOffer"
//           slidingComponentDisplay={true}
//           views="4"
//           used="10"
//         />
//         <OfferExpendable
//           indexKey="2"
//           offerImage={require("../../../../../../assets/images/OfferAndEventImages/eventnew.png")}
//           offerHeadingText="Zomaland"
//           offerStart="25Th Feb 20"
//           offerEnd="25Th Mar 20"
//           offerCodeText="Timing"
//           offerCode="05:00 PM"
//           displayOnwards={true}
//           displayOfferEventOthres={true}
//           address="Royal Palms Pune"
//           couponCodeEvent="8"
//           name="activeOffer"
//           slidingComponentDisplay={true}
//           views="5"
//           used="15"
//         />
//       </React.Fragment>
//     );
//   };

//   render() {
//     return (
//       <React.Fragment>
//         {/* <div className="right-side-panel"> */}
//         <div className="main-offer-event-reusable">
//           <Table responsive className="main-table">
//             <OfferEventTableHeader
//               headerOne="My Events"
//               headerTwo="Views"
//               headerTwoCss="header-tabletwo-width"
//               headerThree="Coupon Code"
//               headerFour="Timing"
//               headerFourCss="header-table-width"
//               headerFive="Start & End Date"
//               headerFiveCss="header-tablefive-width"
//               display={false}
//               headerSix="Active & Inactive"
//               headerSixCss="header-tablesix-width"
//               displayReports={true}
//             />
//             {this.renderTableData()}
//           </Table>
//         </div>

//         {/****************************************************
//                @DESC Offer Mobile View
//                ****************************************************/}
//         <div className="main-offer-event-mobile">
//           <h3 className="reports-heading-text-mobile">
//             Event Report Live Dashboard
//           </h3>
//           <div className="main-offer-event-table">
//             <div className="offer-table-left">
//               <p className="paragraph-width">My Events</p>
//             </div>
//             <div className="offer-table-middle">
//               <p>Start & End Date</p>
//             </div>
//             <div className="offer-table-right text-left">
//               <p>Total</p>
//               <p>Views /Used</p>
//             </div>
//           </div>
//           <Accordion>{this.renderMobileOfferCardView()}</Accordion>
//         </div>
//         {/* </div> */}
//       </React.Fragment>
//     );
//   }
// }

// export default EventsReports;
